import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import NewsSider from './newsSider';
import News from './news';

class NewsAndVideo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { newsSiderData, newsData },
        } = this.props;

        return (
            <div className={styles.box}>
                <NewsSider content={newsSiderData} />
                <News content={newsData} />
            </div>
        );
    }
}

export default errorBoundary(NewsAndVideo);
